module.exports = __webpack_public_path__ + "img/join_content_2__slider_3.c8ad4241.png";